import { useEffect, useState, useCallback } from "react";
import { getProvidersByCompany } from "../services/masterDataService";

export const useProviders = (domain, companyId = null) => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProviders = useCallback(async () => {
    if (!domain || !companyId) {
      setProviders([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await getProvidersByCompany(domain, companyId);
      setProviders(data || []);
    } catch (err) {
      console.error(`Failed to load providers for company ${companyId}:`, err);
      setError(err.message || "Failed to load providers");
      setProviders([]);
    } finally {
      setLoading(false);
    }
  }, [domain, companyId]);

  useEffect(() => {
    fetchProviders();
  }, [fetchProviders]);

  return { 
    providers, 
    loading, 
    error 
  };
};